import { render, staticRenderFns } from "./DeliveriesSummary.vue?vue&type=template&id=2df5cbbd&scoped=true&"
import script from "./DeliveriesSummary.vue?vue&type=script&lang=js&"
export * from "./DeliveriesSummary.vue?vue&type=script&lang=js&"
import style0 from "./DeliveriesSummary.vue?vue&type=style&index=0&id=2df5cbbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df5cbbd",
  null
  
)

export default component.exports